import emptyTruck from 'assets/images/truckEmpty.svg';
import filledTruck from 'assets/images/truckFilled.svg';

import { FOLDER_TYPOLOGIES } from '@/features/easy/preFolderQualification/withoutRORO/types';

export const TypologyImage: React.FunctionComponent<{ folderTypologyTranslationKey: string }> = ({
  folderTypologyTranslationKey,
}) => {
  switch (folderTypologyTranslationKey) {
    case FOLDER_TYPOLOGIES.BORDERC_ROSSING_RORO_EMPTY_DESCRIPTION:
      return <img src={emptyTruck} alt='empty truck' />;

    case FOLDER_TYPOLOGIES.BORDER_CROSSING_RORO_FULL_DESCRIPTION:
      return <img src={filledTruck} alt='filled truck' />;
    default:
      return null;
  }
};
